import React from "react";
import Icon from "components/CommonIcon/Icon";

export const SliderArrows = ({ goNext, goPrevious }) => (
  <div className="mx-auto hidden lg:block">
    <div
      className="absolute flex inset-y-0 -left-30 items-center cursor-pointer"
      onClick={goPrevious}>
      <Icon name="left-arrow-thin" />
    </div>
    <div
      className="absolute flex inset-y-0 -right-30 items-center cursor-pointer"
      onClick={goNext}>
      <Icon name="right-arrow-thin" />
    </div>
  </div>
);
